import { DOCUMENT } from '@angular/common';
import {
  Component,
  OnInit,
  HostListener,
  Renderer2,
  Inject,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Sviluppo Personale';
  argument_route: string;
  backdropRemovalCount: number = 0;

  constructor(
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private readonly document: Document
  ) {
    this.setFavicon(environment.favicon);
  }

  ngOnInit(): void {
    // Subscribe to router events to update title on navigation end
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const urlSegments = this.activatedRoute.snapshot.url;
        if (urlSegments.length > 0) {
          this.argument_route = urlSegments[0].path;
          this.titleService.setTitle(this.argument_route.replace(/-/g, ' '));
        }
      });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      this.removeBackdropRecursively();
    }
  }

  removeBackdropRecursively() {
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop && modalBackdrop.parentNode) {
      modalBackdrop.parentNode.removeChild(modalBackdrop);
      this.backdropRemovalCount++;
      if (this.backdropRemovalCount < 4) {
        this.removeBackdropRecursively();
      } else {
        this.backdropRemovalCount = 0; // Reset counter
      }
    }
  }

  /**
   *
   * @param faviconUrl URL immagine favicon che si trova dentro
   */
  setFavicon(faviconUrl: string): void {
    let link: HTMLLinkElement =
      this.document.querySelector("link[rel~='icon']")!;
    if (!link) {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'icon');
      this.renderer.appendChild(this.document.head, link);
    }
    this.renderer.setAttribute(link, 'href', faviconUrl);
  }
}
